export default "__VITE_ASSET__B9Dyyg9l__"